import { DateTime } from 'luxon';

export const readableDate = (date: Date | string, long = false) => {
  if (typeof date === 'string') {
    return long ? DateTime.fromISO(date).toFormat('dd/MM/yyyy') : DateTime.fromISO(date).toFormat('dd/MM');
  } else {
    return long ? DateTime.fromJSDate(date).toFormat('dd/MM/yyyy') : DateTime.fromJSDate(date).toFormat('dd/MM');
  }
};
export const readableDateAndHour = (date: Date | string, long = false) => {
  if (typeof date === 'string') {
    return long ? DateTime.fromISO(date).toFormat('dd/MM/yyyy') : DateTime.fromISO(date).toFormat('dd/MM hh:mm');
  } else {
    return long ? DateTime.fromJSDate(date).toFormat('dd/MM/yyyy') : DateTime.fromJSDate(date).toFormat('dd/MM hh:mm');
  }
};
